export default {
    methods: {
        errorApi: function(err) {
            var titleMsg = null;
            var alertMsg = '';
            switch (err.id) {
                case 401:
                    alertMsg = err.message;
                    break;
                case 412:
                    alertMsg = "Token invalid";
                    break;
                case 2078:
                    titleMsg = 'Duplicate mobile number'
                    alertMsg = "ขออภัยค่ะ หมายเลขโทรศัพท์ของท่านมีอยู่แล้วในระบบ กรุณาตรวจสอบอีกครั้ง หากไม่สามารถแก้ไขได้ กรุณาติดต่อบัซซี่บีส์ โทร. 02-645-1997";
                    break;
                default:
                    alertMsg = this.lbl.err_network;
            }

            if (this.alertModal != null) {
                this.alertModal.clearModal()
                        .setTitle(titleMsg)
                        .setMsg(alertMsg)
                        .show();
            } else if (this.modalController.alertModal != null) {
                this.modalController.alertModal.clearModal()
                        .setTitle(titleMsg)
                        .setMsg(alertMsg)
                        .show();
            }
        },
    },
}
